export default [
  {
    path: '/admin/suppliers',
    name: 'supplier-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/supplier/profile')
  }
]
